module.exports = __webpack_public_path__ + "static/media/rev.f111c85f.svg";